<template>
  <v-container
      fill-height
      fluid
      pa-0
      class="overflow-y-hidden"
      style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;"
      v-if="show"
  >
    <v-row class="fill-height white--text" no-gutters>
      <top-bar>
        <template v-slot:logos>
          <v-row class="fill-height flex-nowrap pt-6 pl-6" no-gutters>
            <v-col class="flex-shrink-1 pr-4" cols="auto">
              <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
            </v-col>
<!--            <v-col class="flex-shrink-1 " cols="auto">-->
<!--              <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>-->
<!--            </v-col>-->
          </v-row>
        </template>
        <template v-slot:title>Fusion</template>
        <template v-slot:info>
          <v-row class="pt-8 pr-8" justify="end" no-gutters>
            <v-btn dark icon x-large @click="$router.replace(`/${$route.params.app}/menu`)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </template>
      </top-bar>
      <v-col cols="12">
        <v-row no-gutters justify="center" style="position: relative;">
          <v-col cols="12">
            <v-container pa-0>
              <div class="display-1 white--text font-weight-light">
                <v-row no-gutters justify="space-between" align="center">
                  <v-col cols="auto">
                    {{ titleDescription.title }}
                  </v-col>
                  <v-col cols="auto">
                    <v-row dense>
                      <v-col cols="auto" class="pr-6">
                        <v-btn outlined class="rounded-lg" color="white" @click="reset()">
                          Reset
                        </v-btn>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn
                            text
                            class="rounded-lg"
                            color="white"
                            :dark="pitstop === 0"
                            :disabled="pitstop === 0"
                            @click="previous()"
                        >
                          <v-icon>mdi-arrow-left</v-icon>
                          Previous
                        </v-btn>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn
                            text
                            class="rounded-lg"
                            color="white"
                            :dark="pitstop === 3"
                            :disabled="pitstop === 3"
                            @click="next()"
                        >
                          Next
                          <v-icon>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <div class="white--text my-4" style="font-size: 20px;">
                {{ titleDescription.description }}
              </div>
            </v-container>
            <v-window v-model="pitstop">
              <v-window-item eager style="height: 680px;">
                <v-container pa-0>
                  <v-row>
                    <v-col cols="6" :key="index" v-for="(category, index) in dataPitstopProfit.categories">
                      <profit-category-card
                          class="fill-height"
                          :ref="`profit_card_${index}`"
                          :category="category"
                      ></profit-category-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-window-item>
              <v-window-item eager style="height: 680px;">
                <pitstop-process
                    ref="process"
                    :cards="dataPitstopProcess.cards"
                    :tools="dataPitstopProcess.tools"
                ></pitstop-process>
              </v-window-item>
              <v-window-item eager style="height: 680px;">
                <pitstop-people-a ref="peopleA"></pitstop-people-a>
              </v-window-item>
              <v-window-item eager style="height: 680px;">
                <v-row justify="center">
                  <v-col cols="12" :key="index" v-for="(category, index) in dataPitstopPeopleB.categories">
                    <pitstop-people-b :ref="`peopleB_${index}`" :category="category"></pitstop-people-b>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TopBar from "@/components/Framework/TopBar";
import ProfitCategoryCard from "@/views/Tools/SecPeak/Components/ProfitCategoryCard";
import PitstopProcess from "@/views/Tools/SecPeak/Components/PitstopProcess";
import PitstopPeopleA from "@/views/Tools/SecPeak/Components/PitstopPeopleA";
import PitstopPeopleB from "@/views/Tools/SecPeak/Components/PitstopPeopleB";
import UrlParserMixin from "@/mixins/UrlParserMixin";

export default {
  name: "SecPeakFusion",
  mixins: [UrlParserMixin],
  components: {
    TopBar,
    ProfitCategoryCard,
    PitstopPeopleB,
    PitstopPeopleA,
    PitstopProcess,
  },
  data: () => ({
    dataPitstopProfit: null,
    dataPitstopProcess: null,
    dataPitstopPeopleA: null,
    dataPitstopPeopleB: null,
    initialData: null,
    pitstop: 0,
    show: false,
  }),
  computed: {
    titleDescription() {
      switch (this.pitstop) {
        case 0:
          return this.dataPitstopProfit
        case 1:
          return this.dataPitstopProcess
        case 2:
          return this.dataPitstopPeopleA
        case 3:
          return this.dataPitstopPeopleB
      }

      return {}
    }
  },
  methods: {
    setPitstopFormParams() {
      if (this.getParameterByName('pitstop')) {
        let pitstop = this.getParameterByName('pitstop');

        this.pitstop = parseInt(pitstop);
      }
    },
    setParamsFromPitstop() {
      if (history.replaceState) {
        let url = window.location.protocol
            + "//"
            + window.location.host
            + window.location.pathname;

        if (this.pitstop !== null && this.pitstop !== undefined) {
          url += `?pitstop=${this.pitstop}`;
        }

        window.history.replaceState({path: url}, '', url);
      }
    },
    initData() {
      this.dataPitstopProfit = JSON.parse(JSON.stringify(require('@/assets/text/edge_ev_fusion_pitstop_1.json')));
      this.dataPitstopProcess = JSON.parse(JSON.stringify(require('@/assets/text/edge_ev_fusion_pitstop_2.json')));
      this.dataPitstopPeopleA = JSON.parse(JSON.stringify(require('@/assets/text/edge_ev_fusion_pitstop_3A.json')));
      this.dataPitstopPeopleB = JSON.parse(JSON.stringify(require('@/assets/text/edge_ev_fusion_pitstop_3B.json')));

      this.show = true;
    },
    reset() {
      switch (this.pitstop) {
        case 0:
          this.dataPitstopProfit.categories.forEach((_, index) => {
            if (this.$refs[`profit_card_${index}`][0]) {
              this.$refs[`profit_card_${index}`][0].reset();
            }
          });
          break;
        case 1:
          if (this.$refs['process']) {
            this.$refs.process.reset();
          }
          break;
        case 2:
          if (this.$refs['peopleA']) {
            this.$refs.peopleA.reset();
          }
          break;
        case 3:
          this.dataPitstopPeopleB.categories.forEach((_, index) => {
            if (this.$refs[`peopleB_${index}`][0]) {
              this.$refs[`peopleB_${index}`][0].reset()
            }
          });
      }
    },
    previous() {
      this.pitstop--;
      this.setParamsFromPitstop();
    },
    next() {
      this.pitstop++;
      this.setParamsFromPitstop();
    },
  },
  mounted() {
    this.setPitstopFormParams();
    this.initData();
  },
  watch: {
    pitstop() {
      this.initData();
    },
  },
}
</script>

<style scoped>

</style>